<div class="coupon-manager">
  <label for="coupon-input" class="field-label">
    Coupons <span class="optional-badge">Optional</span>
  </label>

  <!-- Coupon Input Section with Autocomplete -->
  <div class="add-coupon-section">
    <p-autocomplete
      inputId="coupon-input"
      [dropdown]="true"
      [formControl]="couponInputControl"
      [suggestions]="filteredCoupons"
      (completeMethod)="searchCoupons($event)"
      (onSelect)="onCouponSelect($event)"
      (onFocus)="onCouponFocus()"
      [disabled]="disabled || isValidating"
      placeholder="Search and add coupon codes..."
      [forceSelection]="false"
      optionLabel="Code"
      styleClass="w-full"
      [minLength]="0"
      [delay]="0"
      appendTo="body"
    >
      <ng-template let-coupon pTemplate="item">
        <div
          class="flex items-center gap-3 p-3 border-b border-gray-100 last:border-b-0"
        >
          <i class="pi pi-ticket text-primary text-base"></i>
          <div class="flex-1">
            <div class="font-semibold text-sm">{{ formatCoupon(coupon) }}</div>
          </div>
        </div>
      </ng-template>
    </p-autocomplete>
  </div>

  <!-- Applied Coupons (Inline Chips) -->
  <div *ngIf="hasCoupons()" class="coupons-display">
    <div class="coupons-chips">
      <div
        *ngFor="let coupon of formGroup.controls.couponsHistory.value"
        class="coupon-chip"
        [class.coupon-invalid]="!coupon.Valid"
        [pTooltip]="getCouponTooltip(coupon)"
        tooltipPosition="top"
      >
        <i [class]="getCouponIcon(coupon)"></i>
        <span class="coupon-code">{{ getCouponLabel(coupon) }}</span>
        <button
          *ngIf="!disabled"
          type="button"
          class="remove-btn"
          (click)="removeCoupon(coupon)"
          [disabled]="disabled"
          [pTooltip]="'Remove ' + coupon.Coupon?.Code"
          tooltipPosition="top"
        >
          <i class="pi pi-times"></i>
        </button>
      </div>
    </div>

    <!-- Validation Status (Inline) -->
    <div *ngIf="validationAttempted && !isValidating" class="validation-status">
      <i
        class="pi"
        [class.pi-check-circle]="allCouponsValid()"
        [class.pi-exclamation-triangle]="hasInvalidCoupons()"
      ></i>
      <span>{{
        allCouponsValid() ? "All coupons valid" : "Some coupons invalid"
      }}</span>
    </div>
  </div>

  <!-- Loading (Minimal) -->
  <div *ngIf="isValidating" class="loading-inline">
    <i class="pi pi-spin pi-spinner"></i>
    <span>Validating...</span>
  </div>

  <!-- Confirm Dialog -->
  <p-confirmDialog />
</div>
